import React, { useCallback, useContext, useMemo } from 'react';
import { Option } from 'kingpin/atoms/ContextMenu';

import ToastContext from '../../../contexts/ToastContext';
import AccountPickerContext from '../../../contexts/AccountPickerContext';
import CurrentUserContext from '../../../contexts/CurrentUserContext';
import RolesContext from '../../../contexts/RolesContext';
import { UIVersionContext } from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';
import PERMISSIONS from '../../../permissionDefinitions';
import getTimeStamp from '../../../getTimeStamp';
import STORE from '../../../store';

const V3UnpublishDashboard = ({ dashboard }: { dashboard: DashboardType }) => {
  const { showToast } = useContext(ToastContext);
  const { selectedAccountId } = useContext(AccountPickerContext);
  const { id: currentUserId } = useContext(CurrentUserContext);
  const { currentPermissions } = useContext(RolesContext);
  const { isV3 } = useContext(UIVersionContext);

  const isOptionAvailable = useMemo(() => {
    if (!isV3) {
      return false;
    }

    if (!dashboard.isV3Published) {
      return false;
    }

    if (
      currentPermissions.includes(
        PERMISSIONS.CONTENT_ACCESS.SET_ANY_AVAILABLE_TO_PRIVATE,
      )
    ) {
      return true;
    }

    if (currentUserId === dashboard.createdBy) {
      return true;
    }

    return false;
  }, [
    currentPermissions,
    currentUserId,
    isV3,
    dashboard.createdBy,
    dashboard.isV3Published,
  ]);

  const onUnpublishClicked = useCallback(() => {
    const newDashboard: DashboardType = {
      ...dashboard,
      isV3Published: false,
      updatedBy: currentUserId,
      updatedOn: getTimeStamp(),
    };

    STORE.getDashboardsRef({
      accountId: selectedAccountId,
    })
      .doc(dashboard.id)
      .set(newDashboard)
      .then(() => {
        showToast(`"${dashboard.name}" has been unpublished successfully!`);
      });
  }, [currentUserId, dashboard, selectedAccountId, showToast]);

  if (!isOptionAvailable) {
    return null;
  }

  return <Option label={'Unpublish'} onClick={onUnpublishClicked} />;
};

export default V3UnpublishDashboard;
